__turbopack_context__.v({
  "c_acquisitionStatus": "Home-module__g21JLG__c_acquisitionStatus",
  "c_pointTable": "Home-module__g21JLG__c_pointTable",
  "c_pointTableList": "Home-module__g21JLG__c_pointTableList",
  "c_stamp_body": "Home-module__g21JLG__c_stamp_body",
  "c_stamp_contents_wrap": "Home-module__g21JLG__c_stamp_contents_wrap",
  "c_stamp_img": "Home-module__g21JLG__c_stamp_img",
  "c_stamp_len": "Home-module__g21JLG__c_stamp_len",
  "circular": "Home-module__g21JLG__circular",
  "square": "Home-module__g21JLG__square",
});
